export const GRID_COLOR = "#e1e0d9";
export const AXIS_COLOR = "#c3c2b7";
export const MUTED_INK = "#898781";
export const SECONDARY_INK = "#52514e";
export const SURFACE = "#ffffff";

export const AXIS_TICK = { fontSize: 12, fill: MUTED_INK };

export function yAxisTitle(title: string) {
  return {
    value: title,
    angle: -90,
    position: "insideLeft" as const,
    style: { textAnchor: "middle", fontSize: 12, fill: MUTED_INK },
  };
}
